// src/components/TaskCard/TaskCard.jsx
import React from 'react';
import { useDispatch } from 'react-redux';
import { openEditModal } from '../../store/slices/tasksSlice.js';
import { PRIORITY_COLORS, TASK_PRIORITY_LABELS } from '../../constants/task.js';
import { formatDueDate, getInitials } from '../../utils/taskUtils.js';

const AVATAR_COLORS = ['#7c6af7', '#5ba4f5', '#e8a838', '#4ade80', '#f87171', '#fb923c'];
function avatarColor(name) {
  if (!name) return AVATAR_COLORS[0];
  let h = 0;
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) % AVATAR_COLORS.length;
  return AVATAR_COLORS[Math.abs(h)];
}

export function PriorityBadge({ priority }) {
  return (
    <span className={`pri pri-${priority}`}>
      {(TASK_PRIORITY_LABELS[priority] || priority).toUpperCase()}
    </span>
  );
}

export function AssigneeAvatar({ name, size = 24 }) {
  return (
    <div
      className="avatar"
      style={{ width: size, height: size, background: avatarColor(name), fontSize: size <= 24 ? 9 : 11 }}
      title={name}
      aria-label={name}
    >
      {getInitials(name)}
    </div>
  );
}

export default function TaskCard({ task, onDragStart }) {
  const dispatch = useDispatch();
  const due = formatDueDate(task.dueDate);

  const handleClick = () => dispatch(openEditModal(task.id));

  const handleDragStart = (e) => {
    e.dataTransfer.setData('taskId', task.id);
    e.dataTransfer.effectAllowed = 'move';
    if (onDragStart) onDragStart(task.id);
  };

  return (
    <div
      className="task-card"
      draggable
      onClick={handleClick}
      onDragStart={handleDragStart}
      role="button"
      tabIndex={0}
      aria-label={`Task: ${task.title}, Priority: ${task.priority}`}
      onKeyDown={(e) => e.key === 'Enter' && handleClick()}
    >
      <span className="drag-handle" aria-hidden="true">⠿</span>

      <div className="task-title">{task.title}</div>

      {task.description && (
        <div className="task-desc">{task.description}</div>
      )}

      <div className="task-meta">
        <PriorityBadge priority={task.priority} />
      </div>

      <div className="task-footer">
        {task.assignee ? (
          <div className="assignee-inline">
            <AssigneeAvatar name={task.assignee} />
            <span>{task.assignee.split(' ')[0]}</span>
          </div>
        ) : (
          <span />
        )}

        {due && (
          <div className={`due-label ${due.cls}`} aria-label={`Due: ${due.label}`}>
            <span>◷</span>
            <span>{due.label}</span>
          </div>
        )}
      </div>
    </div>
  );
}
